module.exports = __webpack_public_path__ + "static/media/albalagh.25fddf98.jpg";